import { SVButton } from '@/components/core';
import { MESSAGES } from '@/constants/messages';
import showToast from '@/utils/toast';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  DialogActions,
} from '@mui/material';
import { UseMutateAsyncFunction } from '@tanstack/react-query';

type ReactivateModalProps = {
  userType: 'Staff' | 'Customer' | 'Company' | 'Teammate';
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  reactivate: UseMutateAsyncFunction<unknown, Error, void, unknown>;
  isReactivatePending: boolean;
  scrollToTop: (behavior?: ScrollBehavior) => void;
};

export default function ReactivateModal({
  userType,
  open,
  setOpen,
  reactivate,
  isReactivatePending,
  scrollToTop,
}: ReactivateModalProps) {
  async function manageReactivate() {
    try {
      await reactivate();
      showToast({
        type: 'success',
        data: { content: `${userType} has been successfully reactivated` },
      });
      setOpen(false);
      scrollToTop();
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Box>
          <Typography variant="h6" component="h2">
            Reactivate Confirmation
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to reactivate this {userType}?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <SVButton onClick={() => setOpen(false)} variant="tertiary">
          No, Don't Activate
        </SVButton>
        <SVButton
          isLoading={isReactivatePending}
          variant="error"
          onClick={manageReactivate}>
          Yes, Reactivate
        </SVButton>
      </DialogActions>
    </Dialog>
  );
}
